import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'pages/AuthProvider';

export default function useUser(id?: string) {
  const {
    clients: { userV2 },
  } = useAuth();
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => {
      if (id) {
        return userV2.getUserV2({ id });
      }
      return null;
    },
  });
}
